import { Controller as BaseController } from '@hotwired/stimulus';

export default class Controller extends BaseController {
  static targets = ['inputField', 'counter', 'currentCount'];

  connect() {
    this.checkFilled();
    if (this.hasCounterTarget) {
      this.updateCounter();
    }
  }

  toggleIconClass(focused) {
    const icons = this.element.querySelectorAll('.component-text-field__icon');
    icons.forEach((icon) => {
      if (focused) {
        icon.classList.add('tw-text-coolGray-700');
        icon.classList.remove('tw-text-coolGray-400');
      } else {
        icon.classList.add('tw-text-coolGray-400');
        icon.classList.remove('tw-text-coolGray-700');
      }
    });
  }

  focus() {
    this.toggleIconClass(true);
  }

  checkFilled() {
    if (!this.hasInputFieldTarget) return;
    if (this.inputFieldTarget === document.activeElement) return;

    const icons = this.element.querySelectorAll('.component-text-field__icon');
    icons.forEach((icon) => {
      if (this.inputFieldTarget.value.trim() !== '') {
        icon.classList.add('tw-text-coolGray-700');
        icon.classList.remove('tw-text-coolGray-400');
      } else {
        icon.classList.add('tw-text-coolGray-400');
        icon.classList.remove('tw-text-coolGray-700');
      }
    });
  }

  blur() {
    this.toggleIconClass(false);
    this.checkFilled();
  }

  updateCounter() {
    if (!this.hasCurrentCountTarget || !this.hasInputFieldTarget) return;

    const currentLength = this.inputFieldTarget.value.length;
    this.currentCountTarget.textContent = currentLength;

    const maxLength = this.inputFieldTarget.getAttribute('maxlength');
    if (maxLength) {
      const remaining = parseInt(maxLength) - currentLength;

      if (remaining < 10) {
        this.counterTarget.classList.add('tw-text-warning-500');
        this.counterTarget.classList.remove('tw-text-coolGray-500');
      } else {
        this.counterTarget.classList.remove('tw-text-warning-500');
        this.counterTarget.classList.add('tw-text-coolGray-500');
      }
    }
  }
}
